const content = {
  title: "Past Simple",
  explanation: `
We use the Past Simple for actions that started and finished in the past.
Example: I visited my grandmother last weekend.

It is common when the time is clear, stated, or understood.
Example: She arrived at 9 p.m.

We use regular verbs with -ed and irregular verbs with their special past forms.
Example: We watched a film, then we went home.

At A2 level, connect events in sequence to tell short past stories clearly.
Example: He woke up late, missed the bus, and took a taxi.
  `,
  rules: [
    "Regular verbs: verb + ed (work → worked)",
    "Irregular verbs change form (go → went, see → saw)",
    "Questions: Did + subject + base verb",
    "Negatives: did not (didn't) + base verb"
  ],
  examples: [
    "I worked yesterday.",
    "She went to school last week.",
    "They watched a movie.",
    "He didn't like the food.",
    "Did you study English?"
  ]
};

export default content;


